import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=69db9cd6&scoped=true"
import script from "./CommunityList.vue?vue&type=script&lang=js"
export * from "./CommunityList.vue?vue&type=script&lang=js"
import style0 from "./CommunityList.vue?vue&type=style&index=0&id=69db9cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69db9cd6",
  null
  
)

export default component.exports